import { useEffect, useState } from "react";
import logo from "../../assets/images/logo/BannerISFsmall.png";
/* import Language from "../Language"; */
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { FaUserPlus } from "react-icons/fa";
import { UseAuth } from "src/auth/AuthContext";
import APIService from "src/services/Api";
import { IoMdClose } from "react-icons/io";
import { ImMenu } from "react-icons/im";
import { MdDashboard } from "react-icons/md";
import DialogInfoGeneral from "../Shared/DialogInfoGeneral";
import RegisterPreForm from "../Register/RegisterPreForm";
import { useAppStateContext } from "src/auth/AppStateContext";
import { getProfileDefaultImage } from "src/helpers/mixins";

const Navbar = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { isAuthenticated, user } = UseAuth();
  const [showMovil, setShowMovil] = useState<boolean>(false);
  const { showRegisterPopup, setShowRegisterPopup,setGoLogin } = useAppStateContext();
  const navigate = useNavigate();
  const [showJoinUs, setShowJoinUs] = useState<boolean>(false);
  useEffect(() => {
    APIService.getToken();
  }, []);

  const { apodo } = useParams();

  const handleLogin = () => {
    if(!apodo && pathname !== '/'){
      navigate('/')
    }else{
      setGoLogin(true)
    }
  }
  const handleVisit = (link: string) => {
    setShowMovil(false);
    if (link !== "/register") {
      navigate(link);
    } else {
      setShowRegisterPopup(true);
    }
  };
  useEffect(() => {
    if (!pathname.includes("/referido/")) {
      setShowJoinUs(true);
    } else {
      setShowJoinUs(false);
    }
  }, [pathname]);

  return (
    <div>
      <nav
        className="bg-white top-0 sm:px-4 py-1 w-full border-b border-stone-400 fixed"
        style={{ zIndex: "1000" }}
      >
        <div className="container flex flex-wrap justify-between items-center mx-auto">
          <a href="/inicio" className="flex items-center py-1">
            <img alt="icon" className="w-20 h-auto" src={logo} />
          </a>
          {!showMovil ? (
            <button
              data-collapse-toggle="mobile-menu"
              onClick={() => setShowMovil(true)}
              type="button"
              className="inline-flex items-center p-2 ml-3 text-sm text-white rounded-lg xl:hidden bg-green-admin-light focus:outline-none"
              aria-controls="mobile-menu"
              aria-expanded="false"
            >
              <ImMenu className="text-white" size={24} />
            </button>
          ) : (
            <button
              data-collapse-toggle="mobile-menu"
              onClick={() => setShowMovil(false)}
              type="button"
              className="inline-flex items-center p-2 ml-3 text-sm text-white rounded-lg xl:hidden bg-green-admin-light focus:outline-none"
              aria-controls="mobile-menu"
              aria-expanded="false"
            >
              <IoMdClose className="text-white" size={27} />
            </button>
          )}
          <div className="hidden w-full xl:block xl:w-auto">
            <ul className="flex flex-col mb-0 items-center mt-4 md:flex-row md:space-x-3 md:mt-0 md:text-sm md:font-normal">
              {isAuthenticated && (
                <li>
                  <Link to="/inicio">
                    <div className="flex relative text-black items-center font-normal gap-2">
                      <div
                        className="w-7 h-7 bg-cover bg-center rounded-full"
                        style={{
                          backgroundImage: `url(${
                            (user?.photoUrl?.length || 0) > 0
                              ? process.env.REACT_APP_PROFILEPICTURE +
                                (user?.photoUrl || "")
                              : getProfileDefaultImage()
                          })`,
                        }}
                      ></div>
                      <div className="font-medium underline text-sm">
                        {user?.fullname?.split(" ")[0]}
                      </div>
                    </div>
                  </Link>
                </li>
              )}
              <li>
                <Link to="/academia">
                  <button className="font-medium opensans text-black rounded-md flex flex-wrap items-center gap-2 sm cursor-pointer transition duration-200 ease-in-out transform  hover:bg-stone-200 px-2 py-2">
                    {t("academytext")}
                  </button>
                </Link>
              </li>
{/*               <li>
                <Link
                  to="https://torneosinfronteras.com?origen=isf"
                  target="_blank"
                >
                  <button className="font-medium opensans text-black rounded-md flex flex-wrap items-center gap-2 sm cursor-pointer transition duration-200 ease-in-out transform  hover:bg-stone-200 px-2 py-2">
                    {t("tournament")}
                  </button>
                </Link>
              </li> */}
              <li>
                <Link to="/videos">
                  <button className="font-medium opensans text-black rounded-md flex flex-wrap items-center gap-2 sm cursor-pointer transition duration-200 ease-in-out transform  hover:bg-stone-200 px-2 py-2">
                    Videos
                  </button>
                </Link>
              </li>
              <li>
                <Link to="/blog">
                  <button className="font-medium opensans text-black rounded-md flex flex-wrap items-center gap-2 sm cursor-pointer transition duration-200 ease-in-out transform  hover:bg-stone-200 px-2 py-2">
                    {t("blogtext")}
                  </button>
                </Link>
              </li>
              <li className="">
                <Link to="/quienes-somos">
                  <button className="font-medium opensans text-black rounded-md flex flex-wrap items-center gap-2 sm cursor-pointer transition duration-200 ease-in-out transform  hover:bg-stone-200 px-2 py-2">
                    {t("aboutus")}
                  </button>
                </Link>
              </li>              
              {!isAuthenticated && (
                <>
                  <li>
                    <button onClick={() => handleLogin()} className="font-semibold opensans border border-gray-500 px-2 py-2 text-black rounded-md flex flex-wrap items-center gap-2 sm cursor-pointer bg-stone-100 transition duration-200 ease-in-out transform  hover:bg-stone-300 px-2 py-2">
                      {t("login")}
                    </button>
                  </li>
                  {showJoinUs && (
                    <li>
                      <div onClick={() => setShowRegisterPopup(true)}>
                        <button className="font-semibold opensans  text-white bg-red-500 rounded-md flex flex-wrap items-center gap-2 sm cursor-pointer transition duration-200 ease-in-out transform px-2 py-2">
                          {t("join")}
                        </button>
                      </div>
                    </li>
                  )}
                </>
              )}
            </ul>
          </div>
        </div>
      </nav>

      <DialogInfoGeneral
        disabledFooter={true}
        size={"xl"}
        show={showRegisterPopup}
        closeDialog={() => setShowRegisterPopup(false)}
        children={<RegisterPreForm />}
      />
      {showMovil && (
        <div className="movil-nav">
          <div className="flex justify-between items-center h-10 w-full border-b shadow-2xl mb-4">
             
          </div>

          <ul className="flex flex-col items-center mt-14 space-y-3 px-6">
            {!isAuthenticated ? (
              <li className="w-full max-w-xs">
                <div onClick={() => handleVisit("/")}>
                  <button className="w-full font-medium text-gray-700 rounded-xl flex items-center justify-center gap-3 text-base cursor-pointer transition-all duration-200 px-4 py-3 shadow-sm bg-white/80 backdrop-blur-sm">
                    <MdDashboard className="text-green-admin-light" size={20} />
                    <span className="font-semibold">{t("home")}</span>
                  </button>
                </div>
              </li>
            ) : (
              <li className="w-full max-w-xs mb-4">
                <Link to="/inicio">
                  <div className="flex flex-col justify-center text-center items-center font-normal gap-3 p-4 bg-gradient-to-r from-green-admin-light/10 to-green-admin/10 rounded-xl border border-green-admin-light/20">
                    <div
                      className="w-12 h-12 bg-cover bg-center rounded-full border-2 border-green-admin-light shadow-lg"
                      style={{
                        backgroundImage: `url(${
                          (user?.photoUrl?.length || 0) > 0
                            ? process.env.REACT_APP_PROFILEPICTURE +
                              (user?.photoUrl || "")
                            : getProfileDefaultImage()
                        })`,
                      }}
                    ></div>
                    <div className="font-semibold text-sm">
                      <div className="text-green-admin-light">Sesión iniciada</div>
                      <div className="text-gray-700">{user?.fullname?.split(" ")[0]}</div>
                    </div>
                  </div>
                </Link>
              </li>
            )}

            {!isAuthenticated && (
              <>
                <li className="w-full max-w-xs">
                  <div onClick={() => handleVisit("/register")}>
                    <button className="w-full font-medium text-gray-700 rounded-xl flex items-center justify-center gap-3 text-base cursor-pointer transition-all duration-200 px-4 py-3 shadow-sm bg-white/80 backdrop-blur-sm">
                      <FaUserPlus size={20} className="text-green-admin-light" />
                      <span className="font-semibold">{t("register")}</span>
                    </button>
                  </div>
                </li>
              </>
            )}

            <li className="w-full max-w-xs">
              <div onClick={() => handleVisit("/quienes-somos")}>
                <button className="w-full font-medium text-gray-700 rounded-xl flex items-center justify-center gap-3 text-base cursor-pointer transition-all duration-200 px-4 py-3 shadow-sm bg-white/80 backdrop-blur-sm">
                  <span className="font-semibold">{t("aboutus")}</span>
                </button>
              </div>
            </li>
            <li className="w-full max-w-xs">
              <div onClick={() => handleVisit("/academia")}>
                <button className="w-full font-medium text-gray-700 rounded-xl flex items-center justify-center gap-3 text-base cursor-pointer transition-all duration-200 px-4 py-3 shadow-sm bg-white/80 backdrop-blur-sm">
                  <span className="font-semibold">{t("academytext")}</span>
                </button>
              </div>
            </li>
{/*             <li className="w-full max-w-xs">
              <Link
                to="https://torneosinfronteras.com?origen=isf"
                target="_blank"
              >
                <button className="w-full font-medium text-gray-700 rounded-xl flex items-center justify-center gap-3 text-base cursor-pointer transition-all duration-200 px-4 py-3 shadow-sm bg-white/80 backdrop-blur-sm">
                  <span className="font-semibold">{t("tournament")}</span>
                </button>
              </Link>
            </li> */}
            <li className="w-full max-w-xs">
              <div onClick={() => handleVisit("/videos")}>
                <button className="w-full font-medium text-gray-700 rounded-xl flex items-center justify-center gap-3 text-base cursor-pointer transition-all duration-200 px-4 py-3 shadow-sm bg-white/80 backdrop-blur-sm">
                  <span className="font-semibold">Videos</span>
                </button>
              </div>
            </li>
            <li className="w-full max-w-xs">
              <div onClick={() => handleVisit("/blog")}>
                <button className="w-full font-medium text-gray-700 rounded-xl flex items-center justify-center gap-3 text-base cursor-pointer transition-all duration-200 px-4 py-3 shadow-sm bg-white/80 backdrop-blur-sm">
                  <span className="font-semibold">{t("blogtext")}</span>
                </button>
              </div>
            </li>
          </ul>
        </div>
      )}
      <div className="mb-6 pb-7"></div>
    </div>
  );
};

export default Navbar;
